import {
  DEFAULT_REDIRECT_URI,
  Tsinghua_REDIRECT_URI,
} from '../config/url'

export const getRedirectURI = () => {
  const search = new URLSearchParams(location.search)
  return search.get('redirectURI') || DEFAULT_REDIRECT_URI
}

export const getTsinghuaURI = () => {
  const search = new URLSearchParams(location.search)
  return search.get('redirectURI') || Tsinghua_REDIRECT_URI
}

export const addQueryString = (URLString, key, value) => {
  const url = new URL(URLString)
  const search = new URLSearchParams(url.search)
  search.append(key, value)

  const href = url.origin + url.pathname;
  const queryString = search.toString();
  return `${href}?${queryString}`
}

export const getSafeRedirectPath = (redirect) => {
  if (!redirect || typeof redirect !== 'string') return '/';

  try {
    const url = new URL(redirect, location.origin);
    if (url.origin !== location.origin) return '/';
    return `${url.pathname}${url.search}${url.hash}`;
  } catch (error) {
    return '/';
  }
}
